import TextField from '@mui/material/TextField';
import React from 'react';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';

import { EMAIL_VALIDATOR_REGEX } from 'src/utils/validators';

const Email = (props: {
  onChange: any;
  isFormSubmitted: boolean;
  className: string;
  value: string;
  floatingLabelFixed: boolean;
  hintText: string;
  disabled: boolean;
}) => {
  const [state, setState] = React.useState({
    value: props.value,
    isEmailValid: false
  });

  const handleEmailChange = (event) => {
    const { value } = event.target;
    const isEmailValid = EMAIL_VALIDATOR_REGEX.test(value);
    setState({
      value,
      isEmailValid
    });
    props.onChange({ email: value, isEmailValid });
  };

  const showErrorText = () => {
    if (props.isFormSubmitted) {
      if (props.value === '') {
        return 'This field is required';
      } else if (!state.isEmailValid) {
        return 'Please enter a valid email';
      }
    }
    return null;
  };

  const { className, hintText, disabled } = props;

  return (
    <TextField
      variant="standard"
      disabled={disabled}
      className={`${className} ${showErrorText() ? 'sl-form-input--error' : ''}`}
      type="text"
      placeholder={hintText}
      helperText={showErrorText()}
      style={{ width: '100%', height: '58px' }}
    >
      <MaskedInput
        mask={emailMask}
        type="text"
        name="email"
        id="email"
        value={state.value}
        onChange={handleEmailChange}
      />
    </TextField>
  );
};

export default Email;
